(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cxk-football-finder"] && !Shopify.designMode) return;
  try {
    
  const initializeFootballFinder = (section) => {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const source = section.querySelector('[data-product-source]');
    const grid = section.querySelector('[data-team-grid]');
    const search = section.querySelector('.cxk-football__search');
    const clear = section.querySelector('.cxk-football__clear');
    const empty = section.querySelector('[data-empty]');
    const showAll = section.querySelector('[data-show-all]');
    const count = section.querySelector('[data-results-count]');
    const title = section.querySelector('[data-results-title]');
    const kicker = section.querySelector('[data-results-kicker]');
    const pills = section.querySelector('[data-team-pills]');
    const popularLimit = Number(section.dataset.popularLimit) || 8;
    const teams = new Map();

    source.querySelectorAll('quick-add-modal').forEach((modal) => {
      document.body.appendChild(modal);
    });

    source.querySelectorAll('.cxk-football-product').forEach((product) => {
      const key = product.dataset.teamKey;
      if (!teams.has(key)) teams.set(key, { key, name: product.dataset.team, products: [] });
      teams.get(key).products.push(product);
    });

    const teamList = Array.from(teams.values());
    teamList.forEach((team, index) => {
      team.products.sort((a, b) => Number(a.dataset.caseOrder) - Number(b.dataset.caseOrder));
      const card = document.createElement('article');
      card.className = 'cxk-football-team';
      card.dataset.teamKey = team.key;
      card.dataset.teamName = team.name.toLowerCase();
      card.dataset.rank = String(index);
      card.innerHTML = `<header class="cxk-football-team__header"><h3></h3><span></span></header><div class="cxk-football-team__types"></div>`;
      card.querySelector('h3').textContent = team.name;
      card.querySelector('header span').textContent = `${team.products.length} case ${team.products.length === 1 ? 'type' : 'types'}`;
      const types = card.querySelector('.cxk-football-team__types');
      team.products.forEach((product) => types.appendChild(product));
      team.card = card;
      grid.appendChild(card);
    });

    source.remove();

    teamList.slice(0, popularLimit).forEach((team) => {
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'cxk-football__pill';
      pill.textContent = team.name;
      pill.addEventListener('click', () => {
        search.value = team.name;
        applyFilter();
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      pills.appendChild(pill);
    });

    function applyFilter(showEverything = false) {
      const query = search.value.trim().toLowerCase();
      let visible = 0;
      teamList.forEach((team, index) => {
        const matches = !query || team.name.toLowerCase().includes(query);
        const shouldShow = matches && (query || showEverything || index < popularLimit);
        team.card.hidden = !shouldShow;
        if (shouldShow) visible += 1;
      });

      clear.hidden = !query;
      empty.hidden = visible !== 0;
      showAll.hidden = Boolean(query) || showEverything || teamList.length <= popularLimit;
      count.textContent = query
        ? (visible ? `${visible} ${visible === 1 ? 'team' : 'teams'} found` : '')
        : `${teamList.length} teams available`;
      title.textContent = query ? `Results for “${search.value.trim()}”` : (showEverything ? 'Every team' : 'Shop by team');
      kicker.textContent = query ? 'Team search' : (showEverything ? 'Full football collection' : 'Most popular');
    }

    let searchTimer;
    search.addEventListener('input', () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(() => applyFilter(), 80);
    });
    clear.addEventListener('click', () => {
      search.value = '';
      search.focus();
      applyFilter();
    });
    showAll.addEventListener('click', () => applyFilter(true));
    applyFilter();
  };

  const initializeFootballFinders = (root = document) => {
    root.querySelectorAll('.cxk-football').forEach(initializeFootballFinder);
  };

  initializeFootballFinders();
  document.addEventListener('shopify:section:load', (event) => initializeFootballFinders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
